// import { Products } from "enums";

export const stationFilterState = (fleetId) => ({
  fleetId,
  page: 1,
  perPage: 10,
  province: "all",
  city: "all",
  platformType: "plb",
  productCodes: [],
});
